import { render, staticRenderFns } from "./TextTranslated.vue?vue&type=template&id=5696999a&scoped=true&"
import script from "./TextTranslated.vue?vue&type=script&lang=js&"
export * from "./TextTranslated.vue?vue&type=script&lang=js&"
import style0 from "./TextTranslated.vue?vue&type=style&index=0&id=5696999a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696999a",
  null
  
)

export default component.exports